import { Modal } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .modal' ) )
     .forEach( modalNode => new Modal( modalNode ) )
